// /themes/mytheme.js
import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

const MonoPreset = definePreset(Aura, {
  semantic: {
    // ana renk artık 2b2b2b
    primary: {
      50: "#f5f5f5",
      100: "#e5e5e5",
      200: "#d4d4d4",
      300: "#a3a3a3",
      400: "#737373",
      500: "#2b2b2b", // 🔥 odak renk
      600: "#242424",
      700: "#1c1c1c",
      800: "#141414",
      900: "#0d0d0d",
      950: "#000000",
    },
    surface: {
      0: "#2b2b2b", // ana arka plan
      50: "#333333",
      100: "#3d3d3d",
      200: "#464646",
      300: "#525252",
      400: "#636363",
      500: "#737373",
      600: "#8a8a8a",
      700: "#b3b3b3",
      800: "#d9d9d9",
      900: "#ffffff",
    },
    info: { 500: "#6b7280" },
    success: { 500: "#6b7280" },
    warning: { 500: "#6b7280" },
    danger: { 500: "#6b7280" },
  },

  components: {
    button: {
      color: "#ffffff",
      background: "{primary.500}", // ana renk 2b2b2b
      hoverBackground: "{primary.600}", // koyulaşan gri
      activeBackground: "{primary.700}",
      borderColor: "{primary.600}",
      focusRing: { width: "2px", style: "solid", color: "{surface.700}" },
      borderRadius: "8px",
    },
    inputtext: {
      background: "{surface.100}",
      color: "#ffffff",
      borderColor: "{surface.200}",
      focusBorderColor: "{surface.600}",
      placeholderColor: "{surface.500}",
    },
    card: {
      background: "{surface.0}",
      color: "#ffffff",
      borderColor: "{surface.100}",
    },
    dialog: {
      background: "{surface.0}",
      color: "#ffffff",
      borderColor: "{surface.200}",
    },
    checkbox: {
      background: "{surface.100}",
      borderColor: "{surface.300}",
      checkedBackground: "{primary.500}",
      checkedBorderColor: "{primary.500}",
      checkColor: "#ffffff",
    },
  },
});

export default {
  preset: MonoPreset,
  options: {
    ripple: true,
    unstyled: false, // Eğer Tailwind gibi framework kullanıyorsan
    prefix: "p",
    cssLayer: {
      name: "primevue",
      order: "app, primevue, overrides",
    },
    darkModeSelector: false, // Sistem temasını dinleme, her zaman açık (light) kalsın
  },
};
